import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { prettyDate } from '@/helpers/utils';
import { streakService } from '../../services/streakService';

export const useGetStreakActivity = params => {
  return useQuery({
    queryKey: [QUERY_KEYS.streak.activity, params],
    queryFn: () =>
      streakService.activity({ limit: 10, ...params }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return {
            ...data,
            grouped: data.list.reduce((acc, item) => {
              const year = prettyDate(item.round_date, 'YYYY');
              acc[year] ? acc[year].push(item) : (acc[year] = [item]);
              return acc;
            }, {}),
          };
        }
        throw new Error('Fetch failed');
      }),
  });
};
